import React from "react";

import { ThemeProvider, makeStyles } from "@material-ui/core";
import ScopedCssBaseline from "@material-ui/core/ScopedCssBaseline";
import PropTypes from "prop-types";

import createTheme from "./createTheme";

const fontSizeMap = {
  small: 12,
  medium: 14,
  large: 16,
};

const useGlobalStyles = makeStyles({
  "@global": {
    html: ({ fontSize }) => ({
      fontSize: fontSizeMap[fontSize],
    }),
    body: ({
      theme: {
        palette: { text },
      },
    }) => ({
      color: text.primary,
    }),
  },
});

const RbThemeProvider = (props) => {
  const {
    primaryColor,
    secondaryColor,
    dark,
    contrast,
    fontSize,
    children,
  } = props;

  const theme = React.useMemo(() => {
    return createTheme({
      secondaryColor,
      primaryColor,
      dark,
      contrast,
    });
  }, [secondaryColor, primaryColor, dark, contrast]);

  useGlobalStyles({ theme, fontSize });

  return (
    <ThemeProvider theme={theme}>
      <ScopedCssBaseline>{children}</ScopedCssBaseline>
    </ThemeProvider>
  );
};

RbThemeProvider.propTypes = {
  dark: PropTypes.bool,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  children: PropTypes.node,
  contrast: PropTypes.number,
  fontSize: PropTypes.oneOf(["small", "medium", "large"]),
};

RbThemeProvider.defaultProps = {
  dark: false,
  primaryColor: "#673AB7",
  secondaryColor: "#ff9800",
  children: null,
  contrast: 30,
  fontSize: "medium",
};

export default React.memo(RbThemeProvider);
